import { useEditSceneModalStateContext } from './EditSceneModalStateContext';
import useSlots from './useSlots';

export default function useSlot(slotIndex?: number) {
  const {
    state: { selectedSlotIndex },
  } = useEditSceneModalStateContext();
  const { slots } = useSlots();
  const targetSlotIndex = slotIndex ?? selectedSlotIndex;
  return slots?.[targetSlotIndex];
}
